import { FC } from "react";
import {
  VerifyCertificateHeroSection,
  VerifyCertificateInfoSection,
} from "@modules/verify-certificate";
import VerifyCertificateSection from "@modules/verify-certificate/Verify";
import useRenderGoftino from "@shared/hooks/useRenderGoftino";

const VerifyCertificate: FC = () => {
  useRenderGoftino("all");

  return (
    <div>
      <VerifyCertificateHeroSection />
      <VerifyCertificateSection />
      <VerifyCertificateInfoSection />
    </div>
  );
};

export default VerifyCertificate;
